import profile_image from '../reviewsData/profile_image.png'
const reviews = [
    {
        id: 1,
        name: 'Stefano Sesana',
        job: 'web developer',
        image: profile_image,
        text:
            "De corazón quería felicitarte, qué lugar tan hermoso el que tienen, las cabañas no solo son espectaculares si no que irradian una energía impresionante, es un sitio para desconectarse de los afanes de la vida y volver a ver las cosas con calma y paz! Todo fue excelente, en serio que no tengo un solo comentario negativo ni algo que no me haya gustado! Si tuviera que dar algo por mejorar sería la ubicación del letrero de la llegada que casi no lo vi estaba tal vez un poco muy metido en la zanja de pasto jajaja pero yo no es que tenga 10/10 en visión! Me voy a volver cliente frecuente y todo el que me pregunte por un sitio en esa zona tenlo por seguro que se los voy a recomendar sin pensarlo dos veces, en serio muchas felicitaciones!",
    },
    {
        id: 2,
        name: 'Claudia',
        job: 'web designer',
        image: profile_image,
        text:
            'El lugar es bonito, es una casa antigua pero muy bien cuidada, Lina sin duda es de gran ayuda con la alimentación, es un muy buen plus, amable y atenta.',
    },
    {
        id: 3,
        name: 'Carlos',
        job: 'intern',
        image: profile_image,
        text:
            'Es una casa de campo en la que se van a sentir cómodos, y en un entorno privado. Es una casa de campo de familia, bo esperen una construcción moderna, es una casa tipo español comida y en donde se sentirán en su casa!. Luisa la propietaria y Patricia la señora que les ayudara con el oficio hacen un equipo espectacular! gracias por todo!\n' +
            'La distancia al casco urbano de Villa de Leyva es como de 15 min en carro, por lo que deben tener esto en cuenta si el plan es de visitar el pueblo y regresar en la noche.\n' +
            'Las camas son cómodas y las sabanas impecables!\n' +
            'Si van en plan familiar esta mas que recomendado.',
    },
    {
        id: 4,
        name: 'Arnold',
        job: 'the boss',
        image: profile_image,
        text:
            'Una casa muy bonita, las personas muy serviciales, seguro volveré. ',
    },
];

export default reviews;